import type { ConversationNodeDialInput } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeDialInput;
};

export function RoutedThroughDialInput({ node }: Props): JSX.Element {
  return (
    <>
      Dial input <strong>{node.variable_id}</strong> ·{' '}
      <strong>{node.input}</strong>
    </>
  );
}
